import { useLazyQuery } from "@apollo/client";
import { useEffect } from "react";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { aws_url_emp, getStaffLogin, suserStatus } from "../../helper";
import { QUERY_USER_INFO } from "./apollo";
import male from "../../img/male.png";
import female from "../../img/female.png";

export default function ProFileInfo() {
  const [show, setShow] = useState(false);
  const userId = getStaffLogin()?.data?._id;
  const [userInfo, setUserInfo] = useState();
  const [fetchData, { data, loading }] = useLazyQuery(QUERY_USER_INFO, {
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    fetchData({
      variables: {
        where: {
          _id: userId,
        },
        limit: 1,
      },
    });
    if (data) {
      setUserInfo(data?.employees?.data[0]);
    }
  }, [show]);

  return (
    <>
      <button
        className="btn border-0 w-100 text-start"
        onClick={() => setShow(true)}
      >
        <i className="icon-user me-1 fs-3" />
        ໂປຣໄຟລ
      </button>
      <hr className="border-t-3 border-secondary mx-4 my-2" />
      <Modal size="md" show={show} centered>
        <Modal.Header closeButton onHide={() => setShow(false)}>
          <Modal.Title className="fs-6 d-flex align-items-center m-0">
            <i className="icon-user fs-3 me-1" />
            ຂໍ້ມູນຜູ້ໃຊ້
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-3 pb-4 px-3">
          <div className="text-center mb-3">
            {userInfo?.gender === "MALE" ? (
              <img
                className="rounded-circle border shadow-sm"
                src={
                  userInfo?.profileImage
                    ? aws_url_emp + userInfo?.profileImage
                    : male
                }
                alt="avatar"
                style={{ width: 120, height: 120, objectFit: "cover" }}
              />
            ) : (
              <img
                className="rounded-circle border shadow-sm"
                src={
                  userInfo?.profileImage
                    ? aws_url_emp + userInfo?.profileImage
                    : female
                }
                alt="avatar"
                style={{ width: 120, height: 120, objectFit: "cover" }}
              />
            )}

            <div className="mt-3">
              <div className="fw-bold fs-5">
                {userInfo?.firstName || ""} {userInfo?.lastName || ""}
              </div>
              <div className="mt-1">
                <span
                  className="badge"
                  style={{
                    backgroundColor: "rgba(183,1,14,0.12)",
                    color: "#db0e0eff",
                    border: "1px solid rgba(183,1,14,0.35)",
                  }}
                >
                  {suserStatus(userInfo?.role || "")}
                </span>
              </div>
            </div>
          </div>

          <div
            className="card border-0 shadow-sm"
            style={{ borderRadius: 16, overflow: "hidden" }}
          >
            <div className="card-body p-3">
              <ul className="list-group list-group-flush">
                <li className="list-group-item px-0 d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center gap-2">
                    <i className="bi bi-hash text-secondary" />
                    <span className="text-muted">ຊື່ ແລະ ນາມສະກຸນ</span>
                  </div>
                  <span className="fw-semibold">
                    {userInfo?.firstName || ""} {userInfo?.lastName || ""}
                  </span>
                </li>

                <li className="list-group-item px-0 d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center gap-2">
                    <i className="bi bi-hash text-secondary" />
                    <span className="text-muted">cvID</span>
                  </div>
                  <span className="fw-semibold">{userInfo?.cvID || "-"}</span>
                </li>

                <li className="list-group-item px-0 d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center gap-2">
                    <i className="bi bi-people text-secondary" />
                    <span className="text-muted">ພະແນກ</span>
                  </div>
                  <span className="fw-semibold">
                    {userInfo?.department?.title_lao || "-"}
                  </span>
                </li>

                <li className="list-group-item px-0 d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center gap-2">
                    <i className="bi bi-briefcase text-secondary" />
                    <span className="text-muted">ຕຳແໜ່ງ</span>
                  </div>
                  <span className="fw-semibold">
                    {userInfo?.position?.title_lao || "-"}
                  </span>
                </li>

                <li className="list-group-item px-0 d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center gap-2">
                    <i className="bi bi-telephone text-secondary" />
                    <span className="text-muted">ເບີໂທ</span>
                  </div>
                  <a
                    href={
                      userInfo?.phoneNumber
                        ? `tel:${userInfo?.phoneNumber}`
                        : "#"
                    }
                    className="fw-semibold text-decoration-none text-primaly "
                  >
                    {userInfo?.phoneNumber || "-"}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
